// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1eQt5","inputWrap":"CustomTip_inputWrap__1EALp"};